import React, { useContext } from "react";
import { default as ClientBatchesContainer } from "./client/BatchesContainer";
import { default as AdminBatchesContainer } from "./admin/BatchesContainer";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { batches } from "../../rbac-consts";

const BatchesWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={batches.USER}
        yes={() => (
          <ClientBatchesContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={batches.ADMIN}
        yes={() => (
          <AdminBatchesContainer />
        )}
      />
    </>
  );
};

export default BatchesWrapper;